import { Component, OnDestroy, ViewChild } from '@angular/core';
import { digger } from '@cbre/digger';
import { SelectComponent } from '@shared/components/inputs/select/select.component';
import { IOption } from '@shared/models/icommons.model';
import { MiqAgColumn } from '../ag-table-grid-options';
import { AgNumericComponent } from './ag-numeric.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'miq-ag-uom',
  templateUrl: './ag-uom.component.html',
  styleUrls: ['./ag-uom.component.scss'],
  standalone: false,
})
export class AgUomComponent extends AgNumericComponent implements OnDestroy {
  state = '';
  values: IOption[] = [];
  dropdownCurrentValue: any = null;

  declare column: MiqAgColumn & { field: string };
  selectColumn: MiqAgColumn & { field: string };

  @ViewChild('selectInput', { read: SelectComponent, static: false }) public selectInput: SelectComponent;

  agInit(params: any): void {
    super.agInit(params);
    this.column = this.params.colDef;
    this.selectColumn = this.column.unit;
    this.values = this.selectColumn.values ?? [];

    const path = this.selectColumn.getReadPath != null ? this.selectColumn.getReadPath() : this.selectColumn.field;
    const updatedPath = path.includes('/') ? path.replaceAll('/', '.0.') : path;
    this.dropdownCurrentValue = digger(params.data, updatedPath);

    this.fc.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      // Set default UOM if none is selected and options are available
      if (!this.dropdownCurrentValue && this.values.length > 0) {
        this.dropdownCurrentValue = this.values[0].key ?? null;
        this.setCurrentValue(this.dropdownCurrentValue);
      }

      // Clear UOM when numeric value is empty
      if (this.fc.value == null || this.fc.value === '') {
        this.dropdownCurrentValue = null;
        this.setCurrentValue(this.dropdownCurrentValue);
      }
    });
  }

  setCurrentValue(newValue: string) {
    this.dropdownCurrentValue = newValue;
    const uomCol = this.params.api.getColumnDef(this.selectColumn.field);
    const path = this.selectColumn.getReadPath != null ? this.selectColumn.getReadPath() : this.selectColumn.field;
    const updatedPath = path.includes('/') ? path.replaceAll('/', '.0.') : path;
    if (uomCol && !updatedPath) {
      // if uom col definition is present in api grid then use it
      this.params.node.setDataValue(uomCol, newValue);
    } else {
      // Automatically triggers the grid's internal change detection for the specific cell, ensuring the UI reflects the updated value.
      //it will invoke the cell valueSetter
      this.params.node.setDataValue(this.selectColumn.field, this.dropdownCurrentValue);
    }
  }

  isPopup(): boolean {
    return true;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.selectInput = null;
  }
}
